import {
  setItem,
} from 'renderer/Global/State/InitData/localStorage/localStorage';
import State from 'renderer/Global/State/State';
import iReducer from 'renderer/Global/State/reducerInterface';

export default function Settings({ state, dispatch }: iReducer) {
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;

    const reader = new FileReader();
    reader.onload = onReaderLoad;
    reader.readAsText(event.target.files[0]);
  };

  function onReaderLoad(event: any) {
    const obj = JSON.parse(event.target.result);
    setItem<State>('spectreSaveData', obj);
    window.location.reload();
  }

  const exportJSON = () => {
    let contentType = 'application/json;charset=utf-8;';
    let a = document.createElement('a');
    a.download = 'saveData.json';
    a.href =
      'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(state));
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div>
      <br />
      <div className="importContainer">
        <div className="importInnerContent">
          <div className="importHeader">
            <div>
              <b>Manage Saves</b>
            </div>
          </div>
          <div className="manageAction">
            <input
              type="file"
              id="saveFile"
              onChange={(event) => handleFileSelect(event)}
            />
          </div>
          <div className="manageAction">
            <button className="manageButton" onClick={() => exportJSON()}>
              Export Current Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
